import { languages } from "shared/types/languages";
import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { TranslationRequestData, TranslationSelectedLanguage, TranslationSuccess, TranslationResponse } from "../types";

async function handleGameNameTranslations({ langCode, data }: TranslationRequestData): Promise<TranslationResponse> {
  const selectedLang = languages.find(language => language.id === langCode)?.name || null;
  const fn = httpsCallable<TranslationRequestData & TranslationSelectedLanguage>(functions, "autoTranslateGameNames");
  try {
    const {data: responseData} = await fn({data, langCode, selectedLang});
    return responseData as TranslationSuccess;
  } catch (error) {
    return {
      errorMessage: (error as Error).message.split(':')[0]
    };
  }
}

export default handleGameNameTranslations;
